const firebaseConfig = {
  apiKey: 'AIzaSyC1Zd2YKmCe138f8ib6g4KyUg0VSOWH7V4',
  authDomain: 'time-tracker-react-fd964.firebaseapp.com',
  databaseURL: 'https://time-tracker-react-fd964.firebaseio.com',
  projectId: 'time-tracker-react-fd964',
  storageBucket: 'time-tracker-react-fd964.appspot.com',
  messagingSenderId: '538720789539'
};

export default firebaseConfig;
